import request from '@/utils/request'
import axios from 'axios'
import {
    getToken
} from '@/utils/auth';
export function getInfo(query) {
    return request({
        url: '/system/user/profile',
        method: 'get',
        params: query
    })
}
export function editInfo(data) {
    return request({
        url: '/system/user/profile',
        method: 'put',
        data: data
    })
}
export function upload(data) {
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + getToken()
        }
    }
    const uploadUrl = process.env.VUE_APP_BASE_API + '/system/File/uploadOssFile'
    return axios.post(uploadUrl, data, config)
}


// 用户修改密码等信息
export function updatePhone(phonenumber, verifyCode) {
    return request({
        url: `/oauth/server-audit/userAudit/upddatePhoneNumber/${phonenumber}/${verifyCode}`,
        method: 'put'
    })
}

// 用户发送手机验证码并校验是否存在
export function sendPhoneCode(query) {
    return request({
        url: `/oauth/server-audit/userAudit/getPhoneNumberRegisterStatus`,
        method: 'get',
        params: query
    })
}

// 获取班级信息
export function getClassInfo(query) {
    return request({
        url: '/system/server-class/class/getClassInfoByUser',
        method: 'get',
        params: query
    })
}

// 获取班级学生信息
export function getStudentInfo(query) {
    return request({
        url: '/system/server-class/class/getStudentInfo',
        method: 'get',
        params: query
    })
}

// 获取汇总信息
export function getSummaryInfo(query) {
    return request({
        url: '/system/server-class/class/getStatisticsSchoolInfo',
        method: 'get',
        params: query
    })
}

// 获取班级学生汇总信息
export function getStudentSummaryInfo(query) {
    return request({
        url: '/system/server-class/class/getStatisticsClassInfo',
        method: 'get',
        params: query
    })
}

// 刷新用户token中的数据
export function refreshUserToken() {
    return request({
        url: '/oauth/server-exam/registeredClient/refreshToken',
        method: 'post'
    })
}

// 获取用户会员套餐信息
export function getMemberPackagesInfo() {
    return request({
        url: '/oauth/server-exam/authorization/getMemberPackagesInfo',
        method: 'get'
    })
}